"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageAccountsScreen = void 0;
const core_1 = require("@emotion/core");
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const redux_1 = require("@/redux");
const selectors_1 = __importDefault(require("@/selectors"));
const utils_1 = require("../../components/table/utils");
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const subcomponents_1 = require("./subcomponents");
const types_1 = require("./types");
const utils_2 = require("./utils");
const { MenuItem } = components_1.Menu;
const ManageAccountsScreen = ({ user, users, filters, pending, pendingBulk, listUsers, bulkUsers, resetFilters, }) => {
    const [isFilterOpen, setIsFilterOpen] = react_1.useState(false);
    const [isBulkActionsOpen, setIsBulkActionsOpen] = react_1.useState(false);
    const [isBulkActionsMenuOpen, setIsBulkActionsMenuOpen] = react_1.useState(false);
    const [selectedRole, setSelectedRole] = react_1.useState(null);
    const [selectedStatus, setSelectedStatus] = react_1.useState(null);
    const [selected, setSelected] = react_1.useState([]);
    const bulkButtonRef = react_1.useRef(null);
    react_1.useEffect(() => {
        if (user && user.id) {
            listUsers(filters);
        }
        return () => resetFilters();
    }, [user]);
    const columnsNames = [
        {
            Header: constants_1.default.manageAccounts.name,
            accessor: 'fullName',
            minWidth: 200,
            sortable: true,
            Cell: subcomponents_1.TableCells.LinkCell,
        },
        {
            Header: constants_1.default.manageAccounts.emailAddress,
            accessor: 'email',
            minWidth: 250,
            sortable: true,
        },
        {
            Header: constants_1.default.manageAccounts.role,
            accessor: 'group',
            minWidth: 100,
            sortable: true,
            Cell: subcomponents_1.TableCells.CapitalizedCell,
        },
        {
            Header: constants_1.default.manageAccounts.status,
            accessor: 'isActive',
            sortable: true,
            Cell: subcomponents_1.TableCells.BadgeCell,
        },
        {
            Header: constants_1.default.manageAccounts.actions,
            Cell: ({ cell }) => {
                const { row } = cell;
                const rowUser = row === null || row === void 0 ? void 0 : row.original;
                return (core_1.jsx(components_1.Button, { title: constants_1.default.manageAccounts.resendInvite, variant: "transparent", ariaLabel: constants_1.default.manageAccounts.resendInvite, onClick: () => {
                        if (pendingBulk)
                            return;
                        bulkUsers({
                            bulkType: types_1.BulkTypes.INVITE,
                            accountIds: [rowUser.id],
                        });
                    }, imgUrls: { default: constants_1.Images.send, selected: constants_1.Images.sendActive }, className: styles_scss_1.default.resendInviteButton }));
            },
        },
    ];
    const onChangeSelected = (values) => {
        setSelected(values);
        if (!lodash_1.isEmpty(values)) {
            setIsBulkActionsOpen(true);
        }
        else {
            setIsBulkActionsOpen(false);
        }
    };
    const onChangeFilters = (values) => {
        listUsers(Object.assign(Object.assign({}, values), { page: 1, nextPage: false }));
    };
    const onChangeSort = (value) => {
        listUsers(Object.assign(Object.assign({}, filters), { ordering: utils_1.cleanSortValue(value), page: 1, nextPage: false }));
    };
    const onSearchChange = lodash_1.debounce((e) => {
        const { value } = e.target;
        const newFilters = Object.assign({}, filters);
        if (value.length === 0) {
            delete newFilters.search;
        }
        else {
            newFilters.search = value;
        }
        onChangeFilters(newFilters);
    }, 300);
    const onChangePage = () => {
        listUsers(Object.assign(Object.assign({}, filters), { page: filters.page + 1, nextPage: true }));
    };
    const columns = react_1.useMemo(() => columnsNames, [users]);
    return (core_1.jsx("div", { className: styles_scss_1.default.manageAccounts },
        core_1.jsx(components_1.Meta, { title: constants_1.default.manageAccounts.helmetTitle, removeViewport: true }),
        core_1.jsx(components_1.Paper, { className: styles_scss_1.default.contentPaper },
            core_1.jsx("h2", null, constants_1.default.manageAccounts.pageTitle),
            core_1.jsx("div", { className: styles_scss_1.default.tableHeaderCont },
                core_1.jsx("div", { className: styles_scss_1.default.tableHeaderLeftCont },
                    core_1.jsx(components_1.SearchInput, { className: styles_scss_1.default.searchInput, ariaLabel: constants_1.default.manageAccounts.searchByName, placeholder: constants_1.default.manageAccounts.searchByName, onChange: onSearchChange, name: "search" }),
                    core_1.jsx(components_1.Button, { className: styles_scss_1.default.filterButton, title: constants_1.default.manageAccounts.filters, ariaLabel: constants_1.default.manageAccounts.filters, isFilter: true, filterCount: [selectedRole, selectedStatus].filter(f => f !== null).length || null, variant: "tertiary-ghost", onClick: () => setIsFilterOpen((prev) => !prev), imgUrls: { default: constants_1.Images.filter, selected: constants_1.Images.filterActive } })),
                core_1.jsx("div", { className: styles_scss_1.default.tableHeaderRightCont },
                    isBulkActionsOpen && (core_1.jsx(react_1.default.Fragment, null,
                        core_1.jsx(components_1.Button, { ref: bulkButtonRef, className: styles_scss_1.default.bulkActionsButton, title: constants_1.default.manageAccounts.bulkActions, ariaLabel: constants_1.default.manageAccounts.bulkActions, variant: "ghost", onClick: () => setIsBulkActionsMenuOpen(true), isToggle: true, disabled: pendingBulk }),
                        core_1.jsx(components_1.Menu, { isOpen: isBulkActionsMenuOpen, buttonRef: bulkButtonRef, offset: { left: -40, top: -129 }, onClose: () => {
                                setIsBulkActionsMenuOpen(false);
                            } },
                            core_1.jsx(MenuItem, { onClick: () => {
                                    if (pendingBulk)
                                        return;
                                    bulkUsers({
                                        bulkType: types_1.BulkTypes.STATUS,
                                        status: types_1.StatusTypes.INACTIVE,
                                        accountIds: selected.map((u) => parseInt(u.id, 10)),
                                    });
                                } }, constants_1.default.manageAccounts.markAsInactive),
                            core_1.jsx(MenuItem, { onClick: () => {
                                    if (pendingBulk)
                                        return;
                                    bulkUsers({
                                        bulkType: types_1.BulkTypes.STATUS,
                                        status: types_1.StatusTypes.ACTIVE,
                                        accountIds: selected.map((u) => parseInt(u.id, 10)),
                                    });
                                } }, constants_1.default.manageAccounts.markAsActive),
                            core_1.jsx(MenuItem, { onClick: () => {
                                    if (pendingBulk)
                                        return;
                                    bulkUsers({
                                        bulkType: types_1.BulkTypes.INVITE,
                                        accountIds: selected.map((u) => parseInt(u.id, 10)),
                                    });
                                } }, constants_1.default.manageAccounts.resendInvite)))),
                    core_1.jsx(components_1.Link, { to: constants_1.Routes.ManageAccountsCreate },
                        core_1.jsx(components_1.Button, { className: styles_scss_1.default.addNewUserButton, variant: "primary", title: constants_1.default.manageAccounts.addNewUser, ariaLabel: constants_1.default.manageAccounts.addNewUser })))),
            isFilterOpen && (core_1.jsx("div", { className: styles_scss_1.default.filtersCont },
                core_1.jsx(components_1.Dropdown, { className: styles_scss_1.default.roleDropdown, ariaLabel: constants_1.default.manageAccounts.selectOneRole, placeholder: constants_1.default.manageAccounts.selectOneRole, value: selectedRole, name: "role", onChange: (option) => {
                        setSelectedRole(option.value === '' ? null : option);
                        onChangeFilters(Object.assign(Object.assign({}, filters), { group: option.value }));
                    }, options: utils_2.roleOptions, label: constants_1.default.manageAccounts.role }),
                core_1.jsx(components_1.Dropdown, { className: styles_scss_1.default.statusDropdown, ariaLabel: constants_1.default.manageAccounts.selectOneStatus, placeholder: constants_1.default.manageAccounts.selectOneStatus, value: selectedStatus, name: "status", onChange: (option) => {
                        setSelectedStatus(option.value === '' ? null : option);
                        onChangeFilters(Object.assign(Object.assign({}, filters), { is_active: option.value }));
                    }, options: utils_2.statusOptions, label: constants_1.default.manageAccounts.status }))),
            core_1.jsx("div", { className: styles_scss_1.default.manageAccountsTable, css: styles_1.default.manageAccountsTable(isFilterOpen) },
                core_1.jsx(components_1.Table, { data: users, columns: columns, searchable: true, selectable: true, onSortChanged: onChangeSort, onChangeSelected: onChangeSelected, onEndReached: onChangePage, loading: pending && !filters.nextPage })))));
};
exports.ManageAccountsScreen = ManageAccountsScreen;
const mapStateToProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
    users: selectors_1.default.user.getUsers(state),
    filters: selectors_1.default.user.getFilters(state),
    pending: selectors_1.default.user.getPending(state),
    pendingBulk: selectors_1.default.user.getPendingBulk(state),
});
const mapDispatchToProps = {
    listUsers: (data) => redux_1.ActionCreators.user.listUsersRequest.dispatch(data),
    bulkUsers: (data) => redux_1.ActionCreators.user.bulkUsersRequest.dispatch(data),
    resetFilters: () => redux_1.ActionCreators.user.resetFilters.dispatch()
};
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.ManageAccountsScreen));
